import { render, staticRenderFns } from "./VendorNotes.vue?vue&type=template&id=3060afda&scoped=true&"
import script from "./VendorNotes.vue?vue&type=script&lang=js&"
export * from "./VendorNotes.vue?vue&type=script&lang=js&"
import style0 from "./VendorNotes.vue?vue&type=style&index=0&id=3060afda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060afda",
  null
  
)

export default component.exports